export * from "./DetailBanner"
export * from "./ModalShare"
export * from "./DetailBody"
export * from "./OtherVacancies"
